import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { constant } from "common/constant";
import colors from "common/theme/foundations/colors";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CommonDeleteModel = (props) => {
  const {
    isOpen,
    onClose,
    type,
    handleDeleteData,
    ids,
    selectedValues,
    notCheckbox = false,
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = () => {
    handleDeleteData(ids, selectedValues);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete {`${type}`}</ModalHeader>
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={props.onClose}
            icon={<CloseIcon />}
          />

          <ModalBody>
            {notCheckbox
              ? `${constant.deleteSingleDesc} ${type}?`
              : ids && ids.length > 1
      ? `${constant.deleteDesc} ${ids.length} ${type}?`
      : `${constant.deleteDesc} ${type}?`}
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-btn2"
              variant="outline"
              size="sm"
              onClick={handleClose}
            >
              No
            </Button>
            <Button
              className="theme-btn3"
              colorScheme={colors.red[500]}
              size="sm"
              ml={4}
              onClick={handleDelete}
              disabled={isLoading ? true : false}
            >
              {isLoading ? <Spinner /> : "Yes, Delete"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default CommonDeleteModel;
